import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteModal } from "../../common/hooks/useDeleteModal";
import { AppSidebar } from "../../common/Sidebar";
import { CreateFolderButton } from "../../common/Sidebar/Components/SidebarButtons/CreateFolderButton";
import { StylistTransferModal } from "../../features/Stylisation/Components/StylistTransferModal";
import { deleteStylistAction } from "../../features/Stylisation/redux/actions";
import { AppDeleteDialog } from "../../shared/components/AppDialog/AppDeleteDialog";
import { useStylistPage } from "./hook/use-stylist-page";
import { ObjectManagerModal } from "../../common/Components/Modals/components/ObjectManagerModal";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { StylistFolderNameChange } from "../../features/Stylisation/Components/StylistFolderNameChange";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";

export const StylistPage = () => {
  const {
    selectedStylist,
    sidebarStylistItems,
    isLoading,
    addStylist,
    addFolder,
    handleSelectStylist,
  } = useStylistPage();
  const {
    deleteInfo,
    isDeleteModalOpen,
    handleDelete,
    openDeleteModal,
    closeDeleteModal,
  } = useDeleteModal(deleteStylistAction);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const [modalNameChangeOpen, setModalNameChangeOpen] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);

  const [selectedId, setSelectedId] = useState<string | null>(null);

  const handleModalOpen = (id: string) => {
    setSelectedId(id);
    setOpen(true);
  };
  const handleModalClose = () => {
    setOpen(false);
  };

  const handleOpenNameChangeModal = (id: string) => {
    setSelectedFolderId(id);
    setModalNameChangeOpen(true);
  };

  const handleCloseNameChangeModal = () => {
    setModalNameChangeOpen(false);
  };

  return (
    <div className={styles["page-layout"]}>
      <AppSidebar
        onAdd={addStylist}
        menuItems={sidebarStylistItems}
        selectedId={selectedStylist?.id}
        onDelete={openDeleteModal}
        onOpenModal={(id) => handleModalOpen(id)}
        onOpenModalNameChange={(id) => handleOpenNameChangeModal(id)}
        service={"stylizator"}
        defaultName={
          t("stylist.default_name") || t("stylist.default_folder_name")
        }
        onSelect={handleSelectStylist}
        isLoading={isLoading}
        isTransfer
        headerAdditionalContent={
          <>
            <CreateFolderButton
              handleCreateFolder={() =>
                handleOpenModal("object_manager", null, "create_folder")
              }
            />
          </>
        }
      />
      {selectedStylist && <SafeOutlet />}
      <AppDeleteDialog
        dialogOpen={isDeleteModalOpen}
        deletingInfo={deleteInfo}
        handleDialogClose={closeDeleteModal}
        onDelete={handleDelete}
      />
      <StylistTransferModal
        open={open}
        childId={selectedId as string}
        closeModal={handleModalClose}
      />
      <ObjectManagerModal
        service={"stylizator"}
        closeModal={handleCloseModal}
        defaultName={t("common.default_folder_name")}
        addFolder={addFolder}
      />
      <StylistFolderNameChange
        open={modalNameChangeOpen}
        childId={selectedFolderId as string}
        closeModal={handleCloseNameChangeModal}
      />
    </div>
  );
};
